<template>
  <b-modal
    centered
    id="change-status-ticket"
    modal-class="overflow-hidden"
    static
    scrollable
    @hidden="onHidden"
  >
    <template #modal-header="{ close }">
      <h5>{{ checkResult }}</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>
    <div>
      <div class="form-group" v-if="checkResult != 'Tạm hoãn'">
        <label>Loại kết quả</label>
        <Select2
          v-model="result"
          :options="dataResult"
          placeholder="Loại kết quả"
          @change="getDataCurrentStateV2"
        />
      </div>
      <div class="form-group">
        <label>Hiện trạng</label>
        <Select2 v-model="currentStateCode" :options="dataCurrentState"> </Select2>
      </div>
      <div class="form-group" v-if="currentStateCode === 'OTHER'">
        <input type="text" v-model="note" />
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button size="sm" variant="primary" @click="updateStatus"> Xác nhận </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { TicketService } from '@/services/ticket.service'
  export default {
    props: {
      ticketId: {
        type: String,
        default: '',
      },
      dataResult: {
        type: Array,
        default: Array,
      },
      checkResult: {
        type: String,
        default: '',
      },
      typeCode: {
        type: String,
      },
    },
    data() {
      return {
        result: '',
        note: '',
        currentStateCode: '',
        dataCurrentState: [],
      }
    },
    created() {
      this.getDataCurrentState()
    },
    methods: {
      async updateStatus() {
        if (this.result === '' && this.checkResult !== 'Tạm hoãn')
          this.showFailMx('Loại kết quả không được để trống')
        else if (this.currentStateCode === '') this.showFailMx('Hiện trạng không được để trống')
        else if (this.currentStateCode === 'OTHER' && this.note == '')
          this.showFailMx('Nhập hiện trạng')
        else {
          const data = {
            currentStateCode: this.currentStateCode,
            result: this.result,
            ticketId: this.ticketId,
          }
          if (this.currentStateCode === 'OTHER') data.note = this.note
          this.$emit('updateStatus', data)
        }
      },
      onHidden() {
        this.$emit('onHidden')
      },
      async getDataCurrentState() {
        if (this.checkResult == 'Hoàn thành' || this.checkResult == 'Đóng hủy') return

        try {
          const params = { applyFor: [this.typeCode] }

          const response = await TicketService.fetchCurrentStateTicket(params)
          if (response.code === 1000) {
            this.dataCurrentState =
              response.data.map(item => ({ id: item.code, text: item.name })) ?? []
            this.dataCurrentState.push({ id: 'OTHER', text: 'Khác' })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getDataCurrentStateV2() {
        if (this.checkResult == 'Tạm hoãn') return

        try {
          let statusDefine = ''
          if (this.checkResult == 'Hoàn thành') {
            statusDefine = 'COMPLETE'
          } else if (this.checkResult == 'Đóng hủy') {
            statusDefine = 'CANCELED'
          }

          console.log('this.result', this.result)

          const params = {
            category: this.typeCode,
            result: this.result,
            status: statusDefine,
          }

          const response = await TicketService.transitionActionResult(params)
          if (response.code === 1000) {
            this.dataCurrentState =
              response.data.map(item => ({ id: item.code, text: item.name })) ?? []
            this.dataCurrentState.push({ id: 'OTHER', text: 'Khác' })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        }
      },
    },
  }
</script>

<style scoped></style>
